import React, { useState } from "react";
import PropTypes from "prop-types";
import Button from "../button";
import { Link } from "react-router-dom";

Category.propTypes = {};

function Category(props) {
	const { data } = props;
	const { className } = props;
	const module = localStorage.getItem('Module')

 
	return (
		<section className={className}>
			<div className="container candidateHomeCat">
				<div className="row">
					<div className="col-md-12 tab-responsive-style">
						<div className="tf-title">
							<div className="group-title">
								<h1>{props.title}</h1>
								<p>{props.text}</p>
							</div>
							{/* <Button title="All Categories" link="/joblist_v1" /> */}
						</div>
					</div>

					
					<div className="group-category-job fadeInUp " data-wow-delay=".2s">

						{module === 'Company' || module === 'Recruiter' ? (
							<>
						
						<Link to="#" className="job-category-box ">
							<div className="job-category-header ">
								<h1>
									<Link to="#">
									  Designation
									</Link>
								</h1>
								<p></p>
							</div>
							<div className="btn-category-job">
								Explore Jobs{" "}
								<span className="icon-keyboard_arrow_right"></span>
							</div>
						</Link>
							</>
						) : ( <>
						<Link to="/Jobs" className="job-category-box ">
							<div className="job-category-header">
								<h1>
									<Link to="/Jobs">
									  Designation
									</Link>
								</h1>
								<p></p>
							</div>
							<div className="btn-category-job">
								Explore Jobs{" "}
								<span className="icon-keyboard_arrow_right"></span>
							</div>
						</Link>
						</>)}

						{module === 'Company' || module === 'Recruiter' ? (

							<>
							<Link to="#" className="job-category-box ">
							<div className="job-category-header">
								<h1>
									<Link to="#">Level</Link>
								</h1>
								<p> Fresher</p>
							</div>
							<div className="btn-category-job">
								Explore Jobs{" "}
								<span className="icon-keyboard_arrow_right"></span>
							</div>
						</Link>
							
							</>
						) :(
							<>
							<Link to="/Jobs" className="job-category-box ">
							 <div className="job-category-header">
								<h1>
									<Link to="/Jobs">Level</Link>
								</h1>
								<p> Fresher</p>
							</div>
							<div className="btn-category-job">
								Explore Jobs{" "}
								<span className="icon-keyboard_arrow_right"></span>
							</div>
						  </Link>
							</>
						)}
						
						{module === 'Company' || module === 'Recruiter' ? (
							<>
							<Link to="#" className="job-category-box ">
							<div className="job-category-header">
								<h1>
									<Link to="#">Mode</Link>
								</h1>
								<p> Remote, Hybrid, Freelancing</p>
							</div>
							<div className="btn-category-job">
								Explore Jobs{" "}
								<span className="icon-keyboard_arrow_right"></span>
							</div>
						</Link>
							</>
						):(
							<>
							
						<Link to="/Jobs" className="job-category-box ">
							<div className="job-category-header">
								<h1>
									<Link to="/Jobs">Mode</Link>
								</h1>
								<p> Remote, Hybrid, Freelancing</p>
							</div>
							<div className="btn-category-job">
								Explore Jobs{" "}
								<span className="icon-keyboard_arrow_right"></span>
							</div>
						    </Link>
							</>
						)} 
						{module === 'Company' || module === 'Recruiter' ? (
							 <>
							 <Link to="#" className="job-category-box ">
							<div className="job-category-header">
								<h1>
									<Link to="#">Industry</Link>
								</h1>
								<p></p>
							</div>
							<div className="btn-category-job">
								Explore Jobs{" "}
								<span className="icon-keyboard_arrow_right"></span>
							</div>
					    	</Link>
							 </>
						 ):(
							<>
							<Link to="/Jobs" className="job-category-box ">
							<div className="job-category-header">
								<h1>
									<Link to="/Jobs">Industry</Link>
								</h1>
								<p></p>
							</div>
							<div className="btn-category-job">
								Explore Jobs{" "}
								<span className="icon-keyboard_arrow_right"></span>
							</div>
					    	</Link>
							</>
						 )}

						{module === 'Company' || module === 'Recruiter' ? (
							<>
							<Link to="#" className="job-category-box">
							<div className="job-category-header">
								<h1>
									<Link to="#">Company</Link>
								</h1>
								<p>Wow-Infobiz</p>
							</div>
							<div className="btn-category-job">
								Explore Jobs{" "}
								<span className="icon-keyboard_arrow_right"></span>
							</div>
						</Link>
							</>
						):(
							<>
							<Link to="/Jobs" className="job-category-box">
							<div className="job-category-header">
								<h1>
									<Link to="/Jobs">Company</Link>
								</h1>
								<p>Wow-Infobiz</p>
							</div>
							<div className="btn-category-job">
								Explore Jobs{" "}
								<span className="icon-keyboard_arrow_right"></span>
							</div>
						</Link>
							</>
						)}
						{module === 'Company' || module === 'Recruiter' ? (
							<>
							<Link to="#" className="job-category-box ">
							<div className="job-category-header">
								<h1>
									<Link to="#">Skills</Link>
								</h1>
								<p></p>
							</div>
							<div className="btn-category-job">
								Explore Jobs{" "}
								<span className="icon-keyboard_arrow_right"></span>
							</div>
						</Link>
							</>
						 ):(
							<>
							<Link to="/Jobs" className="job-category-box ">
							<div className="job-category-header">
								<h1>
									<Link to="/Jobs">Skills</Link>
								</h1>
								<p></p>
							</div>
							<div className="btn-category-job">
								Explore Jobs{" "}
								<span className="icon-keyboard_arrow_right"></span>
							</div>
						</Link>
							</>
						 )}
						
					</div>

					{/* </div> */}
				</div>
			</div>
		</section>
	);
}

export default Category;
